/**
 * FilterDivider - Vertical divider between filter groups
 *
 * Used to visually separate filter groups in filter panels.
 */
import type { ReactElement } from 'react';

export default function FilterDivider(): ReactElement {
  return <div className="bg-storm/30 hidden h-6 w-px sm:block" aria-hidden="true" />;
}
